import styled from 'styled-components'

interface DotWrapperProps {
  color: string
}

export const DotWrapper = styled.span<DotWrapperProps>`
  width: 11px;
  height: 11px;
  background-color: ${(props) => props.color};
  border-radius: 11px;
  display: inline-block;
`
